
export function isCareMoatWebsite() {
    const host = window.location.hostname.toLowerCase();

    return host && (host.includes('caremoat') || host.includes('caremoat.nutristyle.com'));
}